import React from "react";
import {
    CONTEST_STATUS, CONTEST_STATUS_BG, CONTEST_STATUS_TEXT
} from "../UIHelpers";

export const ContestStatusColumnFormatter = (cellContent, row) => (
    <span
        className={`label label-lg text-uppercase ${CONTEST_STATUS_TEXT[row.status]} ${CONTEST_STATUS_BG[row.status]
            } label-inline`}
    >
        {CONTEST_STATUS[row.status]}
    </span>
);
